import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

export default function WartungsprotokollSeite5({ form, setForm }) {

  // Prevent crash when loading from backend (form = null)
  //if (!form) return null;

  const [showZusatz1, setShowZusatz1] = useState(false);
  const [showZusatz2, setShowZusatz2] = useState(false);


  const updateZusatz = (key, idx, field, value) => {
    setForm(prev => {
      const copy = [...prev[key]];
      copy[idx] = { ...copy[idx], [field]: value };
      return { ...prev, [key]: copy };
    });
  };





  return (
      <div className="p-6 text-sm">

        <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
          <h2 style={{ fontWeight: "bold" }}>5 Messungen PV-Anlage</h2>

          <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
              <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
            <tbody>
              {[
                "5.1 Modulstränge wurden gemessen (U_OC, I_SC, R_ISO)",
                "5.2 Alle Modulstränge wurden gemessen (U_OC, I_SC, R_ISO) (bei Unregelmäßigkeiten oder Problemen)",
                "5.3 Erdungswiderstand wurde gemessen",
                "5.4 Erdschlussserkennung durchgeführt",
                "5.5 Messungen gem. DIN EN 62446",
              ].map((text, idx) => {
                const pvRow = form.messungenPV[idx] ?? { ja: false, nein: false, nz: false };
                return (
                  <tr key={idx}>
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                      {text}
                    </td>

                    {/* Ja */}
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={form.messungenPV?.[idx]?.ja || false}
                        onChange={() =>
                          setForm(f => {
                            const list = [...(f.messungenPV || [])];
                            list[idx] = { ja: true, nein: false, nz: false };
                            return { ...f, messungenPV: list };
                          })
                        }
                      />
                    </td>

                    {/* Nein */}
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={form.messungenPV?.[idx]?.nein || false}
                        onChange={() =>
                          setForm(f => {
                            const list = [...(f.messungenPV || [])];
                            list[idx] = { ja: false, nein: true, nz: false };
                            return { ...f, messungenPV: list };
                          })
                        }
                      />
                    </td>

                    {/* Nicht zutreffend */}
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={form.messungenPV?.[idx]?.nz || false}
                        onChange={() =>
                          setForm(f => {
                            const list = [...(f.messungenPV || [])];
                            list[idx] = { ja: false, nein: false, nz: true };
                            return { ...f, messungenPV: list };
                          })
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>


          <Box mb={3} mt={4}>

            <Button
              onClick={() => setShowZusatz1(!showZusatz1)}
              colorScheme="blue"
              borderRadius="lg"
            >
              {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
            </Button>

          </Box>


          {/* ZUSATZ-TABELLE #1 */}
          {showZusatz1 && (
            <>
              <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

              <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
                  </tr>
                </thead>

                <tbody>
                  {(form.zusatz1 || []).map((row, idx) => (
                    <tr key={idx}>
                      {/* Text inputs */}
                      {["zupunkt", "bemerkung", "standort"].map(field => (
                        <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                          <input
                            type="text"
                            value={row[field]}
                            onChange={e => updateZusatz("zusatz1", idx, field, e.target.value)}
                            style={{
                              width: "100%",
                              border: "none",
                              backgroundColor: "#f7f7fb",
                              height: "18px"
                            }}
                          />
                        </td>
                      ))}

                      {/* Plan */}
                      <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                        <input
                          type="checkbox"
                          checked={row.plan}
                          onChange={() => updateZusatz("zusatz1", idx, "plan", !row.plan)}
                        />
                      </td>

                      {/* Bild-Nr */}
                      <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                        <input
                          type="text"
                          value={row.bildnr}
                          onChange={e => updateZusatz("zusatz1", idx, "bildnr", e.target.value)}
                          style={{
                            width: "100%",
                            border: "none",
                            backgroundColor: "#f7f7fb",
                            height: "18px"
                          }}
                        />
                      </td>

                      {/* Beh + n.Beh */}
                      {["beh", "nbeh"].map(field => (
                        <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={row[field]}
                            onChange={() => updateZusatz("zusatz1", idx, field, !row[field])}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </Box>


        <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>

          {/* SECTION 6 */}
          <h2 style={{ fontWeight: "bold" }}>
            6 Prüfung GAKs (extern oder im WR integriert)
          </h2>

          <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse", width: "100%" }}>
          <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
            
            <tbody>
              {[
                "6.1 Alle GAKs sind frei und zugänglich",
                "6.2 Die Strangsicherungen sind funktionsfähig",
                "6.3 Die ÜSS-Einrichtungen sind funktionsfähig",
                "6.4 Die Schalter sind funktionsfähig",
                "6.5 Die GAKs sind frei von Schäden",
                "6.6 Die GAKs sind frei von Feuchtigkeit",
                "6.7 Der innere Zustand der GAKs ist in Ordnung",
                "6.8 Die Erdung der Verteiler ist frei von Schäden und richtig montiert",
                "6.9 Die Beschriftung ist vollständig und i.O.",
                "6.10 Die Kabelverschraubungen sind fest und dicht",
                "6.11 Die Anzugsmomente aller Schrauben sind korrekt",
                "6.12 Die GAKs wurden gereinigt",
                "6.13 Keine Auffälligkeiten aus Thermografieuntersuchung",
              ].map((text, idx) => {

                const gakRow =
                  form.pruefungGAKs[idx] ??
                  { ja: false, nein: false, nz: false, sbm: false, sbeiblatt: false };
                return (
                  <tr key={idx}>
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                      {text}
                    </td>

                    {/* Ja */}
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={form.pruefungGAKs?.[idx]?.ja || false}
                        onChange={() =>
                          setForm(f => {
                            const list = [...(f.pruefungGAKs || [])];
                            list[idx] = { ja: true, nein: false, nz: false };
                            return { ...f, pruefungGAKs: list };
                          })
                        }
                      />
                    </td>

                    {/* Nein */}
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={form.pruefungGAKs?.[idx]?.nein || false}
                        onChange={() =>
                          setForm(f => {
                            const list = [...(f.pruefungGAKs || [])];
                            list[idx] = { ja: false, nein: true, nz: false };
                            return { ...f, pruefungGAKs: list };
                          })
                        }
                      />
                    </td>

                    {/* n.z. */}
                    <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={form.pruefungGAKs?.[idx]?.nz || false}
                        onChange={() =>
                          setForm(f => {
                            const list = [...(f.pruefungGAKs || [])];
                            list[idx] = { ja: false, nein: false, nz: true };
                            return { ...f, pruefungGAKs: list };
                          })
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <Box mb={3} mt={4}>

            <Button
              onClick={() => setShowZusatz2(!showZusatz2)}
              colorScheme="blue"
              borderRadius="lg"
            >
              {showZusatz2 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
            </Button>

          </Box>


          {/* ZUSATZ-TABELLE #2 */}
          {showZusatz2 && (
            <>

              <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

              <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Zu Punkt</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Bemerkungen / Mängel</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "15%" }}>Standort Mangel</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Plan</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>Bild-Nr.</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Beh.</th>
                    <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>n. Beh.</th>
                  </tr>
                </thead>

                <tbody>
                  {(form.zusatz2 || []).map((row, idx) => (
                    <tr key={idx}>
                      {["zupunkt", "bemerkung", "standort"].map(field => (
                        <td key={field} style={{ border: "1px solid #ccc", padding: "3px" }}>
                          <input
                            type="text"
                            value={row[field]}
                            onChange={e => updateZusatz("zusatz2", idx, field, e.target.value)}
                            style={{
                              width: "100%",
                              border: "none",
                              backgroundColor: "#f7f7fb",
                              height: "18px"
                            }}
                          />
                        </td>
                      ))}

                      {/* Plan */}
                      <td style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                        <input
                          type="checkbox"
                          checked={row.plan}
                          onChange={() => updateZusatz("zusatz2", idx, "plan", !row.plan)}
                        />
                      </td>

                      {/* Bild-Nr */}
                      <td style={{ border: "1px solid #ccc", padding: "3px" }}>
                        <input
                          type="text"
                          value={row.bildnr}
                          onChange={e => updateZusatz("zusatz2", idx, "bildnr", e.target.value)}
                          style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb", height: "18px" }}
                        />
                      </td>

                      {/* Beh / n. Beh */}
                      {["beh", "nbeh"].map(field => (
                        <td key={field} style={{ border: "1px solid #ccc", padding: "3px", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={row[field]}
                            onChange={() => updateZusatz("zusatz2", idx, field, !row[field])}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </Box>

      </div>
  );
}